<template>
   <div >
       <!-- Request Demo email starts -->
         <!--4--><section class="" style="background-color: white;">
   <!-- <img v-bind:src="'../imgs/tally_dots_3.png'" width="220" style="position: absolute; margin-top: 0px; right: 230px; opacity: 0.2; bottom:630px " class="dot_3"> -->
	<img v-bind:src="'../imgs/tally_dots_2.png'" width="220" style="position: absolute; margin-top: 162px; right:0; opacity: 0.2; " class="dot_2">

	<img v-bind:src="'../imgs/tally_dots_1.png'" width="200" style="position: absolute; left: 0px; margin-top: 60px;  opacity: 0.2; z-index: 1;" class="dot_1">

   <img v-bind:src="'../imgs/tally_circles_one.png'" width="250" style="position: absolute; left: 0px; margin-top: 350px;  opacity: 0.7; z-index:1;" class="circle">
		 
</section>
<!-- Request Demo email ends -->
  <section class=" clr" >
   
        <div class="container">
            <div class="row ">

    <div class="col-xs-12 col-sm-6">
      <div class="box">
      </div>
    </div>
    
    <div class="col-xs-12 col-sm-6">
      <div class="box">
       <img v-bind:src="'../imgs/tally_dashboard.png'" class="img-fluid" alt="" > 
      </div>
    </div>
                <!-- <div class="flex mb-4 ">
                    <div class="w-1/2  ">
                     
                    </div>
                    <div class="w-1/2 ">
                      <img v-bind:src="'../imgs/tally_dashboard.png'" class="img-fluid" alt="" > 
                    </div>
                </div> -->
               
            </div>
        </div>
  </section>

 <!-- white background -->
<section class="">
 <div class="container mt-14 mb-14 bg-white " >
 <div class="row">
          <div class="text-left col-lg-6 ">
             <!-- <img v-bind:src="'../imgs/tally_dashboard_catalog.png'" class="img-fluid" alt="" >  -->
              <h2 class="text-black text-left">Best features available for your social marketing</h2> 
              <!-- <p class="text-black text-center">Create custom landing pages with fastland that converts more visitors than any website. </p> -->
          </div>
         <div class="justify-end col-lg-6">
            <p class=" text-black text-left ml-6">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptatum, maxime. Dicta, blanditiis.</p>
         </div>

         <!-- cards start from here -->
    <div class="container">
      <div class="row justify-between">
        <div class="col-lg-4 col-md-4 col-12 mt-3 ">
          <div class="box1 shadow-md box5">
            <i class="fas fa-database"></i>
            <h5>Manage smartly</h5>
            <p class="text-gray-400">Stay on top your task lists and stay in touch wit what's happening</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-12 mt-3 ">
          <div class="box1 shadow-md box3">
            <i class="far fa-handshake"></i>
            <h5>Communicate fast</h5>
            <p class="text-gray-400">Stay on top your task lists, stay in touch wit  happening</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-12 mt-3 ">
          <div class="box1 shadow-md box4">
            <i class="fas fa-campground"></i>
            <h5>Influence Easily</h5>
            <p class="text-gray-400">Stay on top your task lists and stay in touch wit what's happening</p>
          </div>
        </div>
      </div>
    </div>
         <!-- cards ends here -->
       </div>
 </div>
</section>
 <!-- white background -->

<!-- start blue background -->
<section style="background-color: white;">
   <img v-bind:src="'../imgs/tally_lines.png'" width="250" style="position: absolute; margin-top: 50px; right: 0px; opacity: 0.6; ">
</section>   

<section>
 <div style="background-color: #2a59ff; margin-top:5px;">
 <div class="container">
<div class="row pt-14 pb-14 text-white">
<div class="text-left col-lg-6">
<h2 class="text-white text-left">Best features available for your social marketing</h2> 
              <p class="text-white text-left">Create custom landing pages with fastland that converts more visitors than any website. </p>
</div>
<div class="text-left col-lg-6 ">
 <!-- <img v-bind:src="'../imgs/tally6.png'" class="img-fluid" alt="" >  -->
 
</div>
<div class="container">
<div class="row">

 <div class="col-lg-4 col-md-4 col-12 mt-3 ">
        <div id="buttons">
         <button class="button button5">Analytics</button>
        </div>
      <h5 class="pt-6 pb-4">Advertisment</h5>
    <p>Sales Report</p></div>
  <div class="col-lg-4 col-md-4 col-12 mt-3 ">
   <h3 class="text-gray-400">01.</h3>
     <h5 class="pt-6 pb-4">Real data access</h5>
    <p> Create custom landing pages with fastland that converts more visitors than any website.</p></div>
 <div class="col-lg-4 col-md-4 col-12 mt-3 ">
     <h3 class="text-gray-400">02.</h3>
      <h5 class="pt-6 pb-4">Daily email reports</h5>
    <p>Create custom landing pages with fastland that converts more visitors than any website.</p></div>
</div>

</div>
</div>  
 </div>
 </div>
</section>
  <!-- end blue background    -->

  <!-- next page design start from here -->
    <section class="pb-14 pt-14 title-section">
        <div class="container ">
            <div class="row">
               <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <h2>Benefit From Our <span style="color:#7140e5">Online Learning</span> Expertise Earn Professional</h2>
                  <table  style="width:100% ;">
                        <tr class="pt-10">
                            <td class="lead icon_style unique-style">
                                <!-- icon will be here -->
                               <i class="fas fa-graduation-cap"></i>
                            </td>
                            <td class="pl-2">
                                <span class="lead unique-style">Online Degrees</span>
                                <div class="lorem-style mb-2">
                                  Manage your work with a single yet powerful console
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td class="lead icon_style unique-style">
                                <!-- icon will be here -->
                                <i class="fas fa-network-wired"></i>
                            </td>
                            <td class="pl-2">
                                <span class="lead unique-style ">Short Courses</span>
                                <div class="lorem-style mb-2">
                                   Integrated with different libraries and technologies
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td class="lead icon_style unique-style">
                                <!-- icon will be here -->
                                <i class="fas fa-hands-helping"></i>
                            </td>
                            <td class="pl-2">
                                <span class="lead unique-style">Learn With Expert</span>
                                <div class="lorem-style mb-2">
                                    Collatorate your work with on a single platform
                                </div>
                            </td>
                        </tr>
                  </table> 
               </div>

                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 text-right">
                    <img v-bind:src="'../imgs/laptop.png'"
                        alt="" class="img-fluid ">
                </div>

            </div>

         </div>
    </section>
  <!-- next page end here -->

  <!-- get instant laptop growth start -->
        <section class="laptop pb-14 pt-14">
        <div class="container ">
            <div class="row">
               <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
                  <img v-bind:src="'../imgs/tally_faster_import.png'"
                        alt=""  class="img-fluid" style="width:75%; height:100%">
               </div>

                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
                    <h2 class="growth">Get Instant growth result for business </h2>
                    <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Deserunt tempore praesentium facilis eius eaque recusandae id enim a ab, voluptatibus ea maxime error ullam explicabo? At quis sit quae ad quod reiciendis?</p>
                </div>

            </div>

         </div>
    </section>
  <!-- get instant growth end -->

   <!-- get instant phone growth start -->
        <section class="phone  pb-14 pt-0" >
        <div class="container ">
            <div class="row">
               <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                  <h2 class="growth">Get Instant growth result for business </h2>
                    <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Deserunt tempore praesentium facilis eius eaque recusandae id enim a ab, voluptatibus ea maxime error ullam explicabo? At quis sit quae ad quod reiciendis?</p>
               </div>

                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 ">
                   <img v-bind:src="'../imgs/tally_faster_import.png'"
                        alt=""  class="img-fluid"  style="width:75%; height:100%">
                </div>
            </div>
         </div>
    </section>
  <!-- get instant growth end -->


  <!-- save your extra money start -->
     <section class="pb-14 pt-14 title-section">
        <div class="container ">
            <div class="row">
               <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <h2 class="import">Save your <span style="color:#7140e5">extra money</span> by using our service.</h2>
                <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolorum sed quo maxime nobis necessitatibus, beatae voluptatum cum laborum ipsum, deserunt itaque veritatis.</p>
               </div>

                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                    <img v-bind:src="'../imgs/tally_faster_growth.png'"
                        alt=""  class="img-fluid faster">
                </div>
            </div>
         </div>
    </section>
  <!-- save your extra money end -->

    <!-- testimonial start from here -->
<div class="container testimonials mt-14">
        <!-- <h1>Testimonials</h1> -->
        <div class="test-body">
            <div class="item">
               <div class="d-flex flex-row">
                 <img src="https://livedemo00.template-help.com/wt_prod-10943/images/testimonials-1-120x120.jpg">
                <div class="name ml-4">Matthew Perkins
                  <br>
                  <span class="small text-gray-500 mr-2">Real Estate</span>
                   </div>
                
                </div>
                <div class="mr-5">⭐⭐⭐⭐⭐</div>
                <p class="text-left">Just had my laptop resurrected and the engineer was fantastic. Very patient, very knowledgeable and knew exactly what he was doing.</p>
            </div>
              <div class="item">
                 <div class="d-flex flex-row">
                 <img src="https://livedemo00.template-help.com/wt_prod-10943/images/testimonials-1-120x120.jpg">
                   <div class="name ml-4">Matthew Perkins
                  <br>
                  <span class="small text-gray-500 mr-2">Real Estate</span>
                   </div>
              </div>
                <div class="mr-5">⭐⭐⭐⭐⭐</div>
                <p>My friend recommended Repair & Fix to me when I had some issues with my laptop. I contacted them and they were very understanding.</p>
            </div>
            <div class="item">
              <div class="d-flex flex-row">
                <img src="https://livedemo00.template-help.com/wt_prod-10943/images/testimonials-3-120x120.jpg">
                <div class="name ml-4">Walter Knight
                  <br>
                <span class="small text-gray-500 mr-2">Photographer</span>
                </div>
              </div>
                <div class="mr-5">⭐⭐⭐⭐⭐</div>
                <p >I have worked with Repair & Fix for several years. They re-built a computer for me and later upgraded it and now it feels just like a new one.</p>
            </div>
        </div>   
</div>
    <!-- testimonial end from here -->

    <!--visitors start from here-->
<!-- 4 columns -->
<!-- <h3>4 Columns</h3> -->
<div class="container">
  <div class="row">
    
    <div class="col-xs-12 col-sm-6 col-md-3">
      <div class="box">
        <span class=" text-3xl text-blue-400 mt-10 text-center">1.5M</span>
        <br>
        <p class="text-center">New visitors every month</p>
      </div>
    </div>
    
    <div class="col-xs-12 col-sm-6 col-md-3">
      <div class="box">
       <span class=" text-3xl text-red-500 mt-10 text-center">49%</span>
        <br>
        <p class="text-center">Extra conversion on any niche</p>
      </div>
    </div>
    
    <div class="col-xs-12 col-sm-6 col-md-3">
      <div class="box">
        <span class=" text-3xl text-green-400 mt-10 text-center ">$2M</span>
        <br>
        <p class="text-center">Extra saved by customer</p>
      </div>
    </div>
    
    <div class="col-xs-12 col-sm-6 col-md-3">
      <div class="box">
       <span class=" text-3xl text-yellow-500 mt-10 text-center">93%</span>
        <br>
        <p class="text-center">Sucess rate on last 05 year</p>
      </div>
    </div>
    
  </div>
</div>
 <!--visitors start from here-->

  </div> 
</template>

   <script>
    
   </script>

    <style scoped>

    template{
       max-width: 100%;
    overflow-x: hidden;
    }
  ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    .clr{
       background: rgba(136, 48, 213, 1.0);
background: -webkit-linear-gradient(left, rgba(136, 48, 213, 1.0), rgba(61, 4, 146, 1.0));
background: -moz-linear-gradient(left, rgba(136, 48, 213, 1.0), rgba(61, 4, 146, 1.0));
background: linear-gradient(to right, rgba(136, 48, 213, 1.0), rgba(61, 4, 146, 1.0));
-webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
        /* height: 50vh; */
        padding-top: 120px;
        padding-bottom: 100px;
    }
   /* cards css start here */
   /* @import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700&display=swap'); */
*{
    font-family: 'Roboto', sans-serif;
}


 /* cards css ends here */

    /* buttons css start */
#buttons{
  width: 80vw;
  margin: auto;
  /* text-align: center; */
}

.button {
  border: none;
  color: white;
  padding: 13px 50px;
  text-align: left;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  /* margin: 50px 20px; */
  transition-duration: 0.4s;
  cursor: pointer;
  border-radius: 5%;
}
.button5 {
  background-color: white;
  color: #2a59ff;
  border: 2px solid #2a59ff;
}

/* .button5:hover {
  background-color: #014b70;
  color: white;
} */
    /* buttons css end */
    /* benefit from our learning start */
    .home-banner-image{
      /* height: 50%; */
      margin-left: 110px;
    }
    .title-section{
      background-color: rgb(233, 245, 248);
    }
     /* benefit from our learning end*/
     .growth{
       margin-top: 190px;
     }
     .import{
       margin-top: 100px;
     }

     /* testimonial css start from here */

h1, h2, h3, h4 ,h5 ,h6, p{
    margin: 0;
    padding: 0;
}
body *{
    -webkit-box-sizing: border-box;
            box-sizing: border-box;
}


.testimonials{
    padding-bottom: 2.2em; 
    text-align: center;
    color: #666;
}
.testimonials h1{
    color: #222;
    font-size: 1.3em;
}
.testimonials .test-body{padding: 1em;}
.testimonials .item{ 
    text-align: center;
    padding: 1em 0;
}
.testimonials img{
    width: 2.8em;
    height: 2.8em;
    border-radius: 50%;
}
.testimonials .name{color: blue;}
.testimonials .desig{
    font-size: 0.6em;
    /* padding: 0.5em 0; */
    color: #777;
}
.testimonials .share{
    margin: 0 auto;
    width: 5em;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}
.testimonials i{
    color: #bfbfbf;
    padding: 0.5em 0;
    -webkit-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
    cursor: pointer;
}
.testimonials i:hover{color: blue;}
.testimonials p{
    max-width: 27em;
    margin: 0 auto;
    font-size: 0.8em;
}

.testimonials button:hover{
    background-color: #444;
}
 /* testinomal media query start fron here */
@media (min-width: 38.4rem){
    .testimonials{
        font-size: 1.2em;
    }
    .testimonials .test-body{
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
            -ms-flex-pack: center;
                justify-content: center;
    }
    .testimonials p{
        text-align: left;
        padding: 1em;
    }
}
     /* testimonial css end from here */

      /* visitors css start from here */
      .box {
  align-items: center;
 margin-top: 20px;
 margin-bottom: 40px;
  padding: 10px;
  color: #aaa;
  padding: 10px;
} 
.box span{
  margin-left: 80px;
}
       /* visitors css end from here */

.box1 {
  margin: 20px 0;
  /* padding: 10px;
  width: 80%; */
  min-height: 200px;
  color: black;
}
.box1 h5{
   margin-top: 70px; 
   margin-bottom: 20px;
}

 /* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .laptop{
    display: none;
  }
  .phone{
    display:block;
  }
  .growth{
       margin-top: 100px;
        margin-bottom: 10px;
     }
     .circle{
   display: none;

  }
  .dot_2{
    width: 140px;
  } 
  .dot_1{
    width: 100px;
  }
    .box span{
      text-align: center;
  margin-left: 225px;
}
     
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .laptop{
    display: none;
  }
  .phone{
    display:block;
  }
  .growth{
       margin-top: 100px;
       margin-bottom: 10px;
     }
    .circle{
    width: 76px;
  }
  .dot_2{
    width: 140px;
  } 
  .dot_1{
    width: 100px;
  }
   .box span{
     text-align: center;
  margin-left: 225px;
}

   
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .laptop{
    display: none;
  }
  .phone{
    display:block;
  }
  .growth{
       margin-top: 100px;
       margin-bottom: 10px;
     }
     /* .faster{
       text-align: center;
       margin-right: 40px;
     } */
     .box3{
       margin-left: 8px;
     }
     .box4{
       margin-left: 16px;
     }
     .circle{
    width: 130px;
  }
  .dot_2{
    width: 140px;
  }
  .dot_1{
    width: 150px;
  }
   .box span{
  margin-left: 15px;
}
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
   .laptop{
    display: block;
  }
  .phone{
    display:none;
  }
 .circle{
    width: 200px;
  }
  .dot_2{
    width: 140px;
  }
  .dot_1{
    width: 170px;
  }
  .box span{
  margin-left: 60px;
}
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1280px) {
  .laptop{
    display: block;
  }
  .phone{
    display:none;
  }
  .circle{
    width: 250px;
  }
  .dot_2{
    width: 200px;
  }
  .dot_1{
    width: 210px;
  }
} 

    </style>